import styled from 'styled-components'
import { PRIMARY_DARK_COLOR, TEXT_GREY } from '@CSSVars/colors'


export const _CalcOutputBox = styled.div`
  width: 100%;
  position: relative;

`

export const _Label = styled.div`
  font-family: var(--secondary-font);
  display: block;
  margin-bottom: 4px;
  font-size: 14px;
  font-weight: ${({ bold }) => (bold ? 700 : 500)};
  line-height: 22px;
  color: ${TEXT_GREY};
  display: flex;
  .tooltipTrigger {
    height: 14px;
    width: 14px;
    font-size: 10px;
    margin-left: 4px;
  }
`

export const _Result = styled.div`
font-family: Montserrat;
font-size: 24px;
font-weight: 600;
line-height: 22px;
color: ${PRIMARY_DARK_COLOR};

`

export const _Suffix = styled.div`
font-family: Montserrat;
font-size: 12px;
font-weight: 500;
line-height: 14.63px;
color: ${TEXT_GREY};
margin-top: 4px;
`
